import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';

import { useCTAButtonVariant } from 'src/app/pages/starterDashboardV2/shared/contexts';
import { useSharePetitionButton } from 'src/app/pages/starterDashboardV2/shared/hooks';

export const SharePetitionButton: React.FC = () => {
	const {
		actions: { handleShareClick },
	} = useSharePetitionButton();
	const { getCTAVariant } = useCTAButtonVariant();

	return (
		<Button
			data-testid="share-petition-button"
			data-qa="share-petition-button"
			variant={getCTAVariant('secondaryEmphasis')}
			size="medium"
			onClick={async () => handleShareClick()}
		>
			<Translate value="corgi.petition.starter_dashboard.grow_petition.share_petition.share_cta" />
		</Button>
	);
};
